module.exports = "/_next/static/images/CustomerStoryAllergan-f76d9821c8462fd3ca61dac3b9673192.png";